<template>
    <transition name="fade-out">
        <div class="login" @keydown.enter="handleSubmit">
       <!-- <div class="login">-->
            <div class="login-con">
                <Card icon="log-in" title="ログイン" :bordered="false">
                    <div class="form-con">
                        <Form ref="loginForm" :model="form" :rules="ruleValidate">
                            <FormItem prop="loginName">
                                <Input v-model="form.loginName" :maxlength="64" :placeholder="t.user.loginName">
                              <span slot="prepend">
                                <Icon type="md-person" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="password">
                                <Input type="password" v-model="form.password" :maxlength="25"
                                       :placeholder="t.user.password">
                              <span slot="prepend">
                                <Icon type="md-lock" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="captcha">
                                <Row>
                                    <Col span="15">
                                        <Input v-model="form.captcha" :maxlength="4" :placeholder="t.user.captcha">
                                      <span slot="prepend">
                                        <Icon type="ios-images" :size="16"/>
                                      </span>
                                        </Input>
                                    </Col>
                                    <Col span="9" style="height:31px;">
                                        <transition name="fade" mode="out-in">
                                            <p class="countdown"
                                               v-if="totalTime>0">
                                                {{totalTime}}
                                            </p>
                                            <img :src="imgSrc" class="captcha"
                                                 @click="generateCaptcha" v-if="totalTime===0"/>
                                        </transition>
                                    </Col>
                                </Row>
                            </FormItem>
                            <div>
                                <Button @click="handleSubmit" type="primary" long>ログイン</Button>
                                <p style="font-size: 12px;text-align:right;margin-top:8px;">

                                    <router-link to="/register">
                                        <Icon type="md-return-right"/>
                                        登録
                                    </router-link>

                                </p>
                            </div>
                        </Form>
                    </div>
                    <Spin fix size="large" v-if="loading">
                        <slot name="loading"></slot>
                    </Spin>
                </Card>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions } from 'vuex';
import { captchaGet, captchaVerify } from '@/api/app';

export default {
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            msgUtil: msgUtil,
            form: {
                loginName: '',
                password: '',
                captcha: '',
            },
            imgSrc: '',
            captchaKey: '',
            totalTime: 0,
            loading: false,
            ruleValidate: {
                loginName: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.loginName),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9a-zA-Z]*$/,
                        message: msgUtil.errorRequiredHalfWidthCharOrNumber(t.user.loginName),
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.password),
                        trigger: 'blur',
                    },
                ],
                captcha: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.captcha),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    computed: {
        rules() {
            return {
                loginName: this.loginNameRules,
                password: this.passwordRules,
                captcha: this.captchaRules,
            };
        },
    },
    methods: {
        ...mapActions('user', ['handleLogin']),
        async handleSubmit({ loginName, password }) {
            this.$refs.loginForm.validate(async valid => {
                this.loading = true;
                if (valid) {
                    try {
                        await this.handleLogin({
                            loginName: this.form.loginName,
                            password: this.form.password,
                            captcha: this.form.captcha,
                            captchaKey: this.captchaKey,
                        });
                        this.$router.push({ name: 'home' });
                    } catch (error) {
                        //console.log(error);
                    }
                }
                this.loading = false;
            });
        },
        async init() {
            let captcha = await captchaGet();
            if (captcha.captcha_key == null || captcha.captcha_key == undefined) {
                this.runCountdown();
                return;
            }
            this.captchaKey = captcha.captcha_key;
            this.imgSrc = 'data:img/jpg;base64,' + captcha.image;
        },
        runCountdown() {
            this.totalTime = 60;
            let clock = window.setInterval(() => {
                this.totalTime--;
                if (this.totalTime <= 0) {
                    window.clearInterval(clock);
                }
            }, 1000);
        },
        generateCaptcha() {
            this.init();
        },
    },
    created() {
        this.init();
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.login {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/login_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    &-con {
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-60%);
        width: 300px;
        &-header {
            font-size: 16px;
            font-weight: 300;
            text-align: center;
            padding: 30px 0;
        }
        .form-con {
            padding: 10px 0 0;
        }
    }
}

.countdown {
    width: 100px;
    height: 31px;
    background-color: #dcdee2;
    margin-top: 1px;
    margin-left: 1px;
    /*margin-bottom: 13px;*/
    font-size: 20px;
    font-weight: bold;
    color: #1f2d3d;
    text-align: center;
}

.captcha {
    margin: 1px;
    width: 100px;
    height: 31px;
    cursor: pointer;
}
</style>
